import { useSession } from 'session/src/hooks/useSession'
import { useSWRConfig } from 'swr'
import { TOTAL_ITEMS_KEY } from '../../constants/constants'
import type { ShoppingCartResponse } from '../../services/graphql.types'
import { FindByUserDocument } from '../../services/queries/find-by-user.generated'
import { FindTotalItemsByUserDocument } from '../../services/queries/find-total-items-by-user.generated'
import { cartTotalItemsCache } from '../../utils/cache/cartTotalItemsCache'

/**
 * Updates the number of items in the cart
 */
export const useUpdateBag = () => {
	const { mutate } = useSWRConfig()
	const { token } = useSession()

	const updateBag = async (
		response: ShoppingCartResponse | null | undefined
	) => {
		if (!response) {
			return
		}

		await cartTotalItemsCache().addKeyToCache(
			TOTAL_ITEMS_KEY,
			response.totalItems
		)
		await mutate(
			[FindTotalItemsByUserDocument],
			{ findTotalItemsByUser: { totalItems: response.totalItems } },
			{ revalidate: false }
		)
		await mutate(
			[FindByUserDocument, undefined, token],
			{ findByUser: response },
			{ revalidate: false }
		)
	}

	return { updateBag }
}
